import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { Controller } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { MuiOtpInput } from 'mui-one-time-password-input';
import useSmsVerification from './smsCode-hook';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';
import { INewOrder } from '../../../../../../../../Interfaces/request-interfaces';
import { ButtonTypes, ICartItem } from '../../../../../../../../Interfaces/componentTypes';
import Button from '../../../../../../../../Components/Button/button';
import { Mobile } from '../../../../../../../../Assets/Icons';
import styles from './smsDialog.module.scss';
import { VisitorPageContents } from '../../../../../visitorPage';

export interface ISmsVerifyProps {
    data: INewOrder,
    setDialog: Dispatch<SetStateAction<ReactNode>>,
    setMainCart: Dispatch<SetStateAction<[] | ICartItem[]>>;
    onCloseDialog: () => void,
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>
}

const SmsCodeDialog: React.FC<ISmsVerifyProps> = (props) => {
    const {
        isValid,
        control,
        canResend,
        isLoading,
        secondsLeft,
        verifyError,
        onVerify,
        handleSubmit,
        onResendCode,
    } = useSmsVerification(props);
    const { phone_number } = props.data;
    const { t } = useLanguagesHooks();

    const progressPercent = (secondsLeft / 60) * 100;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={Mobile} alt="mobile.svg" />
                <p>{t('Visitor.Verify.Title')}</p>
            </div>
            <form onSubmit={handleSubmit(onVerify)} className={styles.form}>
                <div className={styles.subtitle}>
                    <p>
                        <Trans
                            i18nKey="Visitor.Verify.Subtitle"
                            values={{ phone: phone_number }}
                            components={{
                                strong: <span className={styles.phoneNumber} />,
                            }}
                        />
                    </p>
                </div>

                <Controller
                    name="code"
                    control={control}
                    rules={{
                        validate: (value) =>
                            value && value.length === 4 || t('Errors.Code'),
                    }}
                    render={({ field, fieldState }) => (
                        <>
                            <MuiOtpInput
                                aria-required
                                sx={{ gap: 1 }}
                                {...field}
                                length={4}
                                validateChar={(char) => /^\d$/.test(char)}
                                TextFieldsProps={{
                                    type: 'tel',
                                    inputMode: 'numeric',
                                    autoComplete: 'one-time-code',
                                }}
                            />
                        </>
                    )}
                />
                <div className={styles.timerRow}>
                    {!canResend ? (
                        <div className={styles.horizontalTimer}>
                            <div className={styles.progressBarWrapper}>
                                <div
                                    className={styles.progressBarFill}
                                    style={{ width: `${progressPercent}%` }}
                                />
                            </div>
                            <div className={styles.secondsLeft}>{secondsLeft} </div>
                        </div>
                    ) : (
                        <p
                            className={styles.resendText}
                            onClick={onResendCode}
                        >
                            {t('Visitor.Verify.Resend')}
                        </p>
                    )}

                </div>
                <div className={styles.buttonBox}>
                    <div className={styles.errorBox}>
                        <p>{verifyError && t('Errors.SMS')}</p>
                    </div>
                    <Button
                        buttonType={isValid ? ButtonTypes.Primery : ButtonTypes.Disabled}
                        title={t('Buttons.Confirm')}
                        type='submit'
                        disable={!isValid}
                        onClick={handleSubmit(onVerify)}
                        buttonStyle={styles.button}
                        isLoading={isLoading}
                    />
                </div>
            </form>
        </div>
    );
};

export default SmsCodeDialog;
